import { makeTanstackQuery } from '@provider/tanstack';
import { useUserIdentityState } from '@provider/user-identity';
import { DAYS_TO_MS, HOURS_TO_MS } from '@utils/constants';
import { getTeamsRequest } from './api.get-teams.request.js';

const getTeamsQuery = makeTanstackQuery({
  defaultQueryConfig: {
    staleTime: 1 * HOURS_TO_MS,
    gcTime: 7 * DAYS_TO_MS,
    meta: {
      persist: true,
      revalidateOnRefresh: true
    }
  },
  queryKey: input => ["user-area/get-teams", input.user?.id],
  queryFn: input => getTeamsRequest(input.user),
  useQueryInput(queryFactory) {
    const user = useUserIdentityState(state => state.user);
    return queryFactory({
      user
    });
  }
});

export { getTeamsQuery };
//# sourceMappingURL=api.get-teams.query.js.map
